import { FormProvider } from 'react-hook-form';
import { CapaQuotationChatRoomStatus } from '@generated/graphql';
import usePurchaseOrderForm from './hooks/usePurchaseOrderForm';
import CreatePurchaseOrderPresenter from './CreatePurchaseOrderPresenter';
import CreatePurchaseOrderSubmitModal from './CreatePurchaseOrderSubmitModal';
import CreatePurchaseOrderBlockProvider from './CreatePurchaseOrderBlockProvider';
import { ConditionalRender, CustomizedButton } from '@components/Customized';
import { Backdrop, makeStyles, Portal } from '@material-ui/core';
export interface Props {
  chatRoomId?: string;
  chatRoomStatus?: CapaQuotationChatRoomStatus;
  rfqId?: string;
  partnerId?: string;
  onCloseAtDashboard?: () => void;
}

const CreatePurchaseOrderContainer = (props: Props) => {
  const {
    form,
    matches,
    loading,
    partner,
    baseData,
    isClosed,
    rfqDetail,
    isDashboard,
    isPaymentModalOn,
    isPaymentProcessing,
    onSubmit,
    onValidateForm
  } = usePurchaseOrderForm(props);
  const { backDrop } = useStyles();

  return (
    <CreatePurchaseOrderBlockProvider
      isSkip={isDashboard || !baseData}
      isPaymentProcessing={isPaymentProcessing}
    >
      <Portal>
        <ConditionalRender visible={isPaymentModalOn}>
          <Backdrop className={backDrop} open={true} />,
        </ConditionalRender>
      </Portal>

      <FormProvider {...form}>
        <CreatePurchaseOrderPresenter
          loading={loading}
          data={baseData}
          rfqDetail={rfqDetail}
          partner={partner}
          chatRoomId={props.chatRoomId}
          onCloseAtDashboard={props.onCloseAtDashboard}
          submitButton={
            <CreatePurchaseOrderSubmitModal
              onSubmit={onSubmit}
              triggerButton={(onClick) => (
                <CustomizedButton
                  disabled={loading || isClosed}
                  variant="contained"
                  size="large"
                  fullWidth={matches}
                  onClick={onValidateForm(onClick)}
                >
                  <i className="request-gtm-paymentAction-btn">결제하기</i>
                </CustomizedButton>
              )}
            />
          }
        />
      </FormProvider>
    </CreatePurchaseOrderBlockProvider>
  );
};

export default CreatePurchaseOrderContainer;

const useStyles = makeStyles(
  {
    backDrop: {
      zIndex: 10000
    }
  },
  {
    classNamePrefix: 'CreatePurchaseOrderContainer-'
  }
);
